import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import {format} from "date-fns";
import CurrencyFormatter from "../../../../../components/CurrencyFormatter/CurrencyFormatter";
import React, {memo} from "react";
import {useTranslation} from "react-i18next";
import {PaymentTx} from "../../../../../gql/graphql";
export const TransactionsTable = memo((props: { paymentTx: PaymentTx }) => {
    const {t} = useTranslation();
    const {paymentTx} = props;
    let timestampCredit = paymentTx.creditTx?.timeStamp && format(new Date(paymentTx.creditTx?.timeStamp), 'yyyy-MM-dd HH:mm:ss');
    let timestampDebit =  paymentTx.debitTx?.timeStamp && format(new Date(paymentTx.debitTx?.timeStamp), 'yyyy-MM-dd HH:mm:ss');
    return (
        <Table size="small" aria-label="transactions">
            <TableHead sx={{
                '& > tr > th': {
                    borderBottom: 'none',
                    backgroundColor: '#F4F6F8',
                    fontWeight: 600,
                    whiteSpace: 'nowrap'
                },
                '& > tr > th:first-of-type': {
                    borderTopLeftRadius: '8px',
                    borderBottomLeftRadius: '8px',
                },
                '& > tr > th:last-of-type': {
                    borderTopRightRadius: '8px',
                    borderBottomRightRadius: '8px',
                }
            }}>
                <TableRow>
                    <TableCell>{t('timestamp')}</TableCell>
                    <TableCell align="right">{t('amount')}</TableCell>
                    <TableCell align="right">{t('balanceAfter')}</TableCell>
                </TableRow>
            </TableHead>
            <TableBody sx={{
                '& > tr:last-child > td': {
                    borderBottom: 'none'
                }
            }}>
                {paymentTx.creditTx && (
                    <TableRow>
                    <TableCell>{timestampCredit}</TableCell>
                    <TableCell align="right">
                        <CurrencyFormatter currency={'EUR'} quantity={paymentTx.creditTx?.amount}/>
                    </TableCell>
                    <TableCell align="right">
                        <CurrencyFormatter currency={'EUR'} quantity={paymentTx.creditTx?.balanceAfter}/>
                    </TableCell>
                </TableRow>
                   )}
                {paymentTx.debitTx && (<TableRow>
                    <TableCell>{timestampDebit}</TableCell>
                    <TableCell align="right">
                        <CurrencyFormatter currency={'EUR'} quantity={paymentTx.debitTx?.amount}/>
                    </TableCell>
                    <TableCell align="right">
                        <CurrencyFormatter currency={'EUR'} quantity={paymentTx.debitTx?.balanceAfter}/>
                    </TableCell>
                </TableRow>
                )}
            </TableBody>
        </Table>
   );

});